module.exports = {"errorRequired":"This field is required.","errorInvalid":"The format is invalid.","msg":{"saved":"Your ticket has been saved."},"modalTitle":"Select a printer"}


//////////////////
// WEBPACK FOOTER
// ./src/components/CreateCoupon/locales/en.json
// module id = 1713
// module chunks = 0